import store from '@/store'

export default {

  getSolutions: function () {
    var sols = [
      {
        id: 1,
        url: 'creation',
        name: '문서제작 [Word/XML 기술 문서 제작]',
        content: '<strong>표준 제작</strong><br>기업 내 문서 유형별 컨텐츠와 스타일이 포함된 표준 탬플릿 제작 서비스를 제공합니다. 이를 기반으로 협업 환경에서 일관성을 유지할 수 있는 방안을 제공합니다. 필요한 경우 다국어용 탬플릿이 포함됩니다.<br><br><strong>구조화 및 재사용 모델 설계</strong><br>문서의 재사용 및 업데이트 효율 향상을 위하여, 컨텐츠별 구조와 및 모듈화를 설계합니다. 이를 바탕으로 재사용 모델을 설계합니다. 필요한 경우 레가시 문서를 변환하여 신규 문서의 원고로 사용할 수 있도록 재사용을 위한 문서 창고 (Contents Pool)을 제작합니다.<br><br><strong>유연한 작성 도구</strong><br>기존에 많은 기업에서 사용하고 있는 MS Word를 통해 XML 지식에 관계없이 누구나 모듈 컨텐츠로 작성하고 통합 출판할 수 있습니다. 문서의 양과 재사용 구조에 따라 DITA 기반의  Adobe Framemaker 또는 Oxygen XML Editor를 사용한 전통적인 XML 저작도구를 사용할 수 있습니다.<div style="background-image: url(\'/assets/images/Tool-BG.png\'); background-repeat: no-repeat; backgroud-size: cover; padding: 1em; margin: 2em 0; border-radius: 8px;"><p style="color: white;">기술문서 품질 향상을 위한 도구</p><div style="display: flex; justify-content: center; margin: 1em;"><a href="/blog/hound-doc_20220621"><img src="/assets/images/solution/1-HoundDoc.png" alt="" style="width: 100%;"></a><a href="/blog/orthodoc_20220621"><img src="/assets/images/solution/1-OrthoDoc.png" alt="" style="width: 100%;"></a></div></div>',
        cover: '/assets/images/solution/Image.png',
        pane_title: '문서 제작',
        content_title: 'Word/XML 기술 문서 제작',
        solution_icons: [
          '/assets/images/solution/adobe.png',
          '/assets/images/solution/oxygenxml.png',
          '/assets/images/solution/msword.png'

        ],
        summaries: [
          '매뉴얼 표준화, 모듈화 구현',
          '토픽 기반 구조화 저작 구현',
          '재사용 효율성 증대',
          '표준 템플릿 적용을 통한 일관성 구현'
        ],
        images: [
          '/assets/images/solution/1.png',
          '/assets/images/solution/2.jpg'
        ]
      },
      {
        id: 2,
        url: 'management',
        name: '문서 관리 [모듈 컨텐츠 통합 관리]',
        content: '<strong>워크 플로우 관리</strong><br>강력한 워크플로우 및 검색 기능을 갖춘 당사 시스템은 문서 작성자가 재사용할 컨텐츠를 쉽게 찾고 번역 또는 출판할 수 있으며 사전 정의된 워크플로우에 따라 타 부서 및 검토자에게 자동으로 전달하고 알릴 수 있습니다. 작성된 문서는 자체 승인 플로우에 따라 작업 할당 및 이메일 트리거와 같은 기능을 사용하여 쉽게 전달 및 추적할 수 있습니다.<br><br><strong>컨텐츠 재사용</strong><br>컨텐츠의 수 및 크기에 관계없이 문서관리 시스템은 매우 빠른 검색 결과를 제공하여 재사용을 위해 기존 컨텐츠를 선별하는 번거로움을 없애줍니다. 제품 및 문서의 주제와 관련된 광범위한 메타데이터를 통해 기존에 작성한 컨텐츠, 다른 언어로 제작된 컨텐츠 등을 쉽게 찾고 수정 및 재사용을 할 수 있습니다. 재사용 가능한 컨텐츠를 더 빨리 찾는다는 것은 새롭고 멋진 컨텐츠를 만드는 데 더 많은 시간을 할애할 수 있다는 것을 의미합니다.<br><br><strong>버전 관리<br></strong>텍스트리의 문서관리 시스템은 모든 수정 사항과 메모를 자동으로 추적합니다. 이전 작성 버전으로 되돌리거나 수정 사항 비교 도구를 사용하여 기존 문서 간의 차이점을 강조하거나 특정 시점의 전체 문서 상태를 기록할 수 있습니다.컨텐츠 품질을 개선하고 측정하는 것이 그 어느 때보다 쉬워졌습니다.<div style="background-image: url(\'/assets/images/Tool-BG.png\'); background-repeat: no-repeat; backgroud-size: cover; padding: 1em; margin: 2em 0; border-radius: 8px;"><p style="color: white;">문서 제작 및 관리 도구</p><div style="display: flex; justify-content: center; margin: 1em;"><a href="/blog/contentree-cms_20220621"><img src="/assets/images/solution/2-CMS.png" alt="" style="width: 100%;"><a/><a href="/blog/contentree-studio_20220621"><img src="/assets/images/solution/2-Studio.png" alt="" style="width: 100%;"></a></div></div>',
        cover: '/assets/images/solution/cms.png',
        pane_title: '문서 관리',
        content_title: '모듈 컨텐츠 통합 관리',
        solution_icons: [
          '/assets/images/solution/CONTENTree-05.png',
          '/assets/images/solution/CONTENTree-03.png',

        ],
        summaries: [
          '매뉴얼 표준화, 모듈화 구현',
          '저작 산출물 저장 및 버전 관리 구축',
          '저작 리소스 공유/검색 기능 제공',
          '태그 정보를 활용한 자동 분류 및 검색 필터 지원'
        ],
        images: [
          '/assets/images/solution/2.1.jpg',
          '/assets/images/solution/2.2.jpg',
          '/assets/images/solution/2.3.png'
        ]
      },
      {
        id: 3,
        url: 'publishing',
        name: '문서 출판 [다채널 자동 출판]',
        content:'<strong>자유로움과 유연성</strong><br>기술문서 컨텐츠를 모든 프레임워크를 통해 다양한 형식으로 게시할 수 있습니다. 싱글소스출판으로 기업들이 하나의 기술문서에서 인쇄물, PDF, 워드문서, HTML 등을 포함한 다양한 요구형식으로 자동적으로 출판이 가능하도록 하는 시스템을 구축합니다. <br><br><strong>서버 기반 퍼블리싱 </strong><br>지능형 출판 시스템을 통해 기업의 다양한 컨텐츠를 중앙에서 생성하고 관리하십시오. 통합 인터페이스로 서버에서 빠르게 PDF 컨텐츠를 인쇄 매체는 물론 디지털 방식으로 출판할 수 있습니다.<br><br><strong>로컬 퍼블리싱</strong><br> 다양한 환경에서 각종 출판 기능 요소를 구현합니다. 웹 게시용 및 인쇄용 PDF를 직접 출판할 수 있으며 스마트폰, 태블릿, 일반 PC 웹 브라우저 등 다양한 디바이스를 지원합니다.',
        cover: '/assets/images/solution/viewer.jpg',
        pane_title: '문서 출판',
        content_title: '모듈 컨텐츠 통합 관리',
        solution_icons: [
          '/assets/images/solution/pdf.png',
          '/assets/images/solution/HTML.png'
        ],
        summaries: [
          '싱글 소스를 활용한 PDF, Web, Mobile 등의 다양한 매뉴얼 자동 출판'
        ],
        images: [
          '/assets/images/solution/Picture1.png',
          '/assets/images/solution/Picture2.png'
        ]
      },
      {
        id: 4,
        url: 'distribution',
        name: '문서 배포 [컨텐츠 배포 포털]',
        content: '<strong><br>컨텐츠 배포 허브 구축</strong><br> 중앙 시스템에서 기업이 보유하고 있는 채널과의 연동이 가능하며 고객이 쉽고 정확하게 필요한 기업의 다양한 기술문서 컨텐츠를 찾을 수 있는 배포 포털 시스템을 구축할 수 있습니다.<br><strong><br>일관된 컨텐츠 커뮤니케이션</strong><br> 기업의 다양한 컨텐츠를 중앙에서 생성하고 관리하십시오. 통합 인터페이스로 한 번에 컨텐츠를 인쇄 매체는 물론 웹사이트 및 모바일 환경에서 쉽고 빠르게 접근할 수 있는 APP 개발이 가능합니다.(PC 웹브라우저, 태블릿, 스마트폰 등 다양한 디바이스 및 Cross-Browser 지원)<br><br><strong>고객의 접근성 향상</strong><br> 기업의 다양한 기술문서 컨텐츠를 관리자가 액세스 가능한 채널에 더 빠르고 저렴하게 게시할 수 있으며 기업의 고객 누구나 컨텐츠에 쉽게 액세스할 수 있습니다. 고객이 액세스 가능한 자료를 제공하는 데 수정 지연이나 비용이 발생하지 않으며 기업의 컨텐츠는 프로세스 속도를 높일 수 있습니다.',
        cover: '/assets/images/solution/app.jpg',
        pane_title: '문서 배포',
        content_title: '모듈 컨텐츠 통합 관리',
        solution_icons: [
          '/assets/images/solution/mobile.png',
          '/assets/images/solution/webport.png'
        ],
        summaries: [
          '검색, 개인화 환경을 지원하는 문서 포털 ',
          '사용성 분석을 통한 컨텐츠 인사이트 확보',
          'API를 통한 기존 시스템/앱과의 연계'
        ],
        images: [
          '/assets/images/solution/pic1.png',
          '/assets/images/solution/pic2.png'
        ]
      }
    ]
    store.commit('SET_SOLUTION_SOLUTIONS', sols)
  }

}
